export default {
  SET_LIS(state, LIs) {
    state.LIs = Array.isArray(LIs) ? LIs : [];
  },
  SET_ANUENCIA(state, anuencia) {
    state.anuencia = Array.isArray(anuencia) ? anuencia : [];
  },
  SET_ITENS(state, itens) {
    state.itens = Array.isArray(itens) ? itens : [];
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
};
